<template>
    <div>
        <b-modal
            id="export-or-send-popup"
            ref="modal"
            title="Export Process"
            size="sm"
            hide-footer
            modal-class="hide-footer"
            :hide-header-close="loading"
            no-close-on-backdrop
            no-close-on-esc
        >
            <p class="m-custom">
                Would you like to download report data or send it through email
                ?
            </p>

            <b-form
                @submit.stop.prevent="exportReport()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <div class="export-radio-section">
                            <div class="icon-section">
                                <div class="excel-icons">
                                    <pdf-icon></pdf-icon>
                                </div>
                                <div class="pdf-icons">
                                    <excel-icon></excel-icon>
                                </div>
                            </div>
                            <div class="export-form-section">
                                <b-form-group class="export-files">
                                    <b-form-radio-group
                                        v-model="exportType"
                                        :options="form.exportType"
                                        name="export"
                                    ></b-form-radio-group>
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        :class="loading ? 'disabled' : ''"
                        btn-label="Confirm"
                        btn-type="submit"
                        btn-variant="primary"
                    ></base-button>
                    <base-button
                        :disabled="loading"
                        btn-label="Cancel"
                        btn-type="reset"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import excelIcon from '@/components/icons/ExcelIcon.vue'
import pdfIcon from '@/components/icons/PdfIcon.vue'
import _ from 'lodash'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        excelIcon,
        pdfIcon,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        query: {
            type: Object,
            required: false,
        },
        modalTitle: {
            type: String,
            default: 'Export Process',
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            exportType: 'download',
            form: {
                exportType: [
                    {
                        text: 'Download Profile',
                        value: 'download',
                    },
                    {
                        text: 'Send Profile on Email',
                        value: 'sendEmail',
                    },
                ],
            },
        }
    },

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'loading',
            'hidePopup',
            'chartsHeadings',
            'dataSegmentId',
            'hasScopes',
        ]),
    },
    watch: {
        exportType(newVal) {
            this.$emit('setSendEmail', newVal == 'sendEmail')
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async exportReport() {
            this.onHidden()
            this.$emit('startDownload')
        }, //end of exportReport()

        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            this.$refs.modal.hide()
        }, // End of onHidden() method
        /**
         * Export Activity Timeline
         *
         * @return {void}
         */
    },
}
</script>
